// components/MicrophonePermission.js
'use client';

import { useState, useEffect } from 'react';

export default function MicrophonePermission({ children }) {
  const [permissionGranted, setPermissionGranted] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Prüfen ob Berechtigung bereits gespeichert ist
    const savedPermission = localStorage.getItem('microphonePermission');
    
    if (savedPermission === 'granted') {
      setPermissionGranted(true);
    } else if (savedPermission === 'denied') {
      // Berechtigung wurde abgelehnt - nichts tun
      setPermissionGranted(false);
    } else {
      // Noch keine Entscheidung getroffen - Prompt anzeigen
      setShowPrompt(true);
    }
  }, []);

  const requestMicrophonePermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // Berechtigung erteilt
      setPermissionGranted(true);
      setShowPrompt(false);
      localStorage.setItem('microphonePermission', 'granted');
      // Stream wieder stoppen
      stream.getTracks().forEach(track => track.stop());
    } catch (error) {
      console.error('Mikrofon Zugriff verweigert:', error);
      localStorage.setItem('microphonePermission', 'denied');
      setShowPrompt(false);
    }
  };

  const denyPermission = () => {
    localStorage.setItem('microphonePermission', 'denied');
    setShowPrompt(false);
  };

  if (showPrompt) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-md mx-4">
          <h2 className="text-xl font-bold mb-4">Mikrofon Zugriff erforderlich</h2>
          <p className="mb-4 text-gray-600">
            Für die Nutzung des CRM Systems benötigen wir Zugriff auf dein Mikrofon. 
            Bitte erlaube den Zugriff, um alle Funktionen nutzen zu können.
          </p>
          <div className="flex gap-3">
            <button
              onClick={requestMicrophonePermission}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
            >
              Erlauben
            </button>
            <button
              onClick={denyPermission}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400 transition"
            >
              Ablehnen
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
}